<template>
<div>
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <a class="navbar-brand" href="#">Dashboard</a>
      <button type="button"
              class="navbar-toggler navbar-toggler-right"
              :class="{toggled: $sidebar.showSidebar}"
              aria-controls="navigation-index"
              aria-expanded="false"
              aria-label="Toggle navigation"
              @click="toggleSidebar">
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-end">
        <ul class="nav navbar-nav mr-auto">
        </ul>
        <ul class="navbar-nav ml-auto">
          <base-dropdown v-if="mainRole === 'OWNER'" tag="li">
  <template slot="title">
    <b-icon icon="bell-fill" aria-hidden="true"></b-icon> Overdue List
    <b class="caret"></b>
    <span class="notification">{{ contractNotification.length }}</span>
  </template>
  <a v-for="(notification, index) in contractNotification" :key="index" class="dropdown-item"" style="border-bottom: 3px solid rgb(240, 206, 13, 0.937);">
    <div class="row">
      <div class="col-md-12">
        <h6 style="color:rgb(37, 91, 48)">
        <b-icon style="color: rgba(240, 206, 13, 0.937)" icon="people-fill" aria-hidden="true"></b-icon>
        {{ notification.tenantName }}</h6>
      </div>
      <div class="col-md-12">
        <h6 style="color:rgb(37, 91, 48)">
        <b-icon style="color: rgba(240, 206, 13, 0.937)" icon="telephone-fill" aria-hidden="true"></b-icon></i>
        {{ notification.tenantPhoneNumber }}</h6> 
      </div>
      <div class="col-md-12">
        <h6 style="color:rgb(37, 91, 48)">
        <b-icon style="color: rgba(240, 206, 13, 0.937)" icon="house-fill" aria-hidden="true"></b-icon></i>
        {{ notification.houseInfo }}</h6>
      </div>
    </div>
  </a>
</base-dropdown>
           <li class="nav-item">
            <a @click="ViewAccount" class="nav-link">
              Account
            </a>
          </li>
          <li class="nav-item">
            <a @click="signOut" class="nav-link">
              Log out
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  <div class="row">
        <b-modal
            id="modal-center-account"
            hide-footer
            title="Account"
            content-class="shadow" 
          >
            <template #modal-header="{ close }">
              <h5>Account</h5>
              <p class="h5 mb-2">
                <b-icon
                  icon="x-square"
                  class="close-icon"
                  @click="
                    close();
                    clearData();
                  "
                ></b-icon>
              </p>
            </template>
                <b-row no-gutters>
                  <b-col md="12" class="profile-icon">
                    <b-icon icon="person-bounding-box"></b-icon>
                  </b-col>
                </b-row>
                <b-row no-gutters class="mt-2">
                  <b-col xs="6" class="left-profile">
                    <b-row class="left-prof">First Name</b-row>
                    <b-row class="left-prof">Last Name</b-row>
                    <b-row class="left-prof">User Name</b-row>
                    <b-row class="left-prof">Phone Number</b-row>
                    <b-row class="left-prof">Email</b-row>
                    
                  </b-col>
                  <b-col xs="4" class="right-profile">
                    <b-row class="right-prof">{{accountData.firstName}}</b-row>
                    <b-row class="right-prof">{{accountData.lastName}}</b-row>
                    <b-row class="right-prof">{{accountData.username}}</b-row>
                    <b-row class="right-prof">{{accountData.phoneNumber}}</b-row>
                    <b-row class="right-prof">{{accountData.email}}</b-row>
                  </b-col>
                </b-row>
                <b-row no-gutters class="mt-2 changePWD">
                  <b-button @click="changePassword()" class="btn-outline-primary" size="sm" style="font-weight: 700;">
                      Change Password
                  </b-button>
                </b-row>
          </b-modal>
  </div>
  <div class="row">
      <b-modal
          id="modal-center-changePwd"
          hide-footer
          title="Change Password"
          content-class="shadow" 
        >
          <template #modal-header="{ close }">
            <h5>Change Password</h5>
            <p class="h5 mb-2">
              <b-icon
                icon="x-square"
                class="close-icon"
                @click="
                  close();
                  clearData();
                "
              ></b-icon>
            </p>
          </template>
          <validation-observer ref="observer" v-slot="{ handleSubmit }">
            <b-form
              class="text-left"
              @submit.stop.prevent="handleSubmit(submitChangeForm)"
            >
              <b-row no-gutters>
                <b-col
                  md="12"
                  style="justify-content: center; align-items: center"
                >
                  <Vinput
                    inputType="password"
                    :modelValue="addData.oldPassword"
                    @update:modelValue="
                      (newValue) => (addData.oldPassword = newValue)
                    "
                    :rules="{ required: true }"
                    id="text-oldPassword"
                    name="text-oldPassword"
                    label="Old Password"
                    class="mb-1 mr-sm-2"
                    description="text-oldPassword-feedback"
                    validatorName="Old Password"
                  />
                </b-col>
                <b-col
                  md="12"
                  style="justify-content: center; align-items: center"
                >
                    <Vinput
                    inputType="password"
                    :modelValue="addData.newPassword"
                    @update:modelValue="
                      (newValue) => (addData.newPassword = newValue)
                    "
                    :rules="{ required: true }"
                    id="text-newPassword"
                    name="text-newPassword"
                    label="New Password"
                    class="mb-1 mr-sm-2"
                    description="text-newPassword-feedback"
                    validatorName="New Password"
                  />
                </b-col>
                  <b-col
                  md="12"
                  style="justify-content: center; align-items: center"
                >
                    <Vinput
                    inputType="password"
                    :modelValue="addData.confirmPassword"
                    @update:modelValue="
                      (newValue) => (addData.confirmPassword = newValue)
                    "
                    :rules="{ required: true }"
                    id="text-confirmPassword"
                    name="text-confirmPassword"
                    label="Confirm Password"
                    class="mb-1 mr-sm-2"
                    description="text-confirmPassword-feedback"
                    validatorName="Confirm Password"
                  />
                </b-col>
                <b-col md="12"
                  style="justify-content: center; align-items: center;" >
                The length of your Password must be a minimum of 8 characters
                which includes Uppercase,lowercase, number and special character.
                </b-col>
                <b-col class="mt-2">
                  <b-button type="submit" variant="primary">Submit</b-button>
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
        </b-modal>
  </div>
</div>
</template>
<script>
import Vinput from 'src/components/Inputs/Vinput.vue'
  export default {
    components: {
      Vinput
    },
    data () {
      return {
        mainRole: sessionStorage.getItem("mainRole"),
        activeNotifications: false,
        contractNotification: [],
        accountData:{
          firstName: "",
          lastName: "",
          userName: "",
          email: "",
          phonenumber: "",
          accountNumber: ""
        },
        addData: {
          userId: sessionStorage.getItem("userID"),
          newPassword: "",
          oldPassword: "",
          confirmPassword: ""
        }
      }
    },
    mounted(){
      //this.getTenantsWithPaymentStatus();
     this.ViewNotification(sessionStorage.getItem("ID"));
    },
    methods: {
      signOut(){
          this.$store.dispatch('Logout')
          .then(()=>{
              this.$router.push('/');
          })
          .catch(error =>{
              //console.log(error);
          });
      },
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown () {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown () {
        this.activeNotifications = false
      },
      toggleSidebar () {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar () {
        this.$sidebar.displaySidebar(false)
      },
      ViewAccount(){
        this.$store.dispatch('getAccountByID', {id: sessionStorage.getItem("userID")})
          .then(response=>{
            this.accountData.firstName = response.data.firstName;
            this.accountData.lastName = response.data.lastName;
            this.accountData.username = response.data.username;
            this.accountData.email = response.data.email;
            this.accountData.phoneNumber = response.data.phoneNumber;
            this.accountData.accountNumber = response.data.accountNumber;
            this.$bvModal.show('modal-center-account');
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              //console.log(error);
          })
      },
        ViewNotification(ID) {
        const role = sessionStorage.getItem("mainRole");
        const action = (role === 'OWNER' || role === 'ADMIN' || role === 'SUPER_ADMIN')
          ? 'getOverdueContractNotification'
          : role === 'COLLECTOR' ? 'getOverdueContractNotificationOwner' : null;
        if (!action) return;
        this.$store.dispatch(action, { userId: ID })
          .then(response => {
            this.contractNotification = response.data.notification;
          })
          .catch(error => {
            console.log("Notification error:", error);
          });
      },
      changePassword(){
        this.$bvModal.show('modal-center-changePwd');
      },
      checkPasswordComplexity(password){
        let validationRegex = [
            { regex: /.{8,}/ }, // min 8 letters,
            { regex: /[0-9]/ }, // numbers from 0 - 9
            { regex: /[a-z]/ }, // letters from a - z (lowercase)
            { regex: /[A-Z]/}, // letters from A-Z (uppercase),
            { regex: /[^A-Za-z0-9]/} // special characters
        ]

        var checkValid =  true;
        validationRegex.forEach((item, i) => {
          var isValid = item.regex.test(password);
          checkValid = isValid
          return
        }); 
        return checkValid;
      },
      submitChangeForm(){
        this.$bvModal.msgBoxConfirm('Are you sure you want to change your password?', {
              title: 'Confirm',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'success',
              cancelVariant: 'danger',
              okTitle: 'YES',
              cancelTitle: 'NO',
              bodyClass: 'm-2',
              hideHeaderClose: false,
              centered: false
          })
        .then(value => {
            if(value === true){
              if(this.addData.newPassword === this.addData.confirmPassword){
                //console.log("password", this.addData.newPassword, this.checkPasswordComplexity(this.addData.newPassword));
                if(this.checkPasswordComplexity(this.addData.newPassword)){
                  this.$store.dispatch('changePassword', this.addData)
                  .then(response=>{
                      this.$notifications.notify(
                        {
                          message: `Password successfully changed.`,
                          horizontalAlign: 'center',
                          verticalAlign: 'top',
                          type: 'success'
                        })
                        this.$bvModal.hide('modal-center-changePwd');
                        this.$bvModal.hide('modal-center-account');
                        this.clearData();
                  })
                  .catch(error=>{
                      //console.log(error);
                      this.$notifications.notify(
                        {
                          message: error.response.data,
                          horizontalAlign: 'center',
                          verticalAlign: 'top',
                          type: 'danger'
                        })
                  })
                }else{
                  this.$notifications.notify(
                  {
                    message: `Not valid password.`,
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                  })
                }
              }else{
                this.$notifications.notify(
                {
                  message: `Password did not match.`,
                  horizontalAlign: 'center',
                  verticalAlign: 'top',
                  type: 'danger'
                })
              }
            }
        })
        .catch(error=>{
            //console.log(error)
        })
      }
    }
  }

</script>
<style scoped>
.nav-item{
  cursor: pointer;
}
.profile-icon{
  font-size: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgba(240, 206, 13, 0.937);
  margin-right: 40px;
}
.left-profile{
  text-align: right;
  color: rgb(37, 91, 48);
}
.right-profile{
  border-left: 2px solid rgba(240, 206, 13, 0.937);
  padding-left: 40px;
}
.left-prof{
  justify-content: right;
  text-align: right !important;
  margin-right: 20px;
}
.right-prof{
  justify-content: left;
  text-align: left !important;
  margin-right: 5px;
}
@media (min-width: 768px) {
  .profile-icon{
    padding-right: 40px;
  }
}
.changePWD{
    display: flex;
    justify-content: center;
    align-items: center;
}
@media (min-width: 768px) {
  .changePWD{
    padding-right: 40px;
  }
}
</style>
